import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Window, StatCard, Loading } from "../../components/VB";
import { useAuth } from "../../contexts/AuthContext";

export default function EmployeeDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/dashboard/karyawan");
        setData(data);
      } catch (e) { console.error(e); }
      setLoading(false);
    })();
  }, []);

  if (loading) return <Loading />;
  if (!data) return null;

  return (
    <div style={{ padding: 0 }}>
      <Window title={`Dashboard Karyawan - ${user?.name}`}>
        <h2 className="vb-h1">Ringkasan Bulan {data.bulan}</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 10, marginTop: 12 }}>
          <StatCard label="Total Hadir" value={data.total_hadir} testId="emp-stat-hadir" />
          <StatCard label="Tidak Hadir" value={data.total_tidak_hadir} testId="emp-stat-tidakhadir" />
          <StatCard label="Izin" value={data.total_izin} testId="emp-stat-izin" />
          <StatCard label="Sakit" value={data.total_sakit} testId="emp-stat-sakit" />
          <StatCard label="Izin Pending" value={data.izin_pending} testId="emp-stat-pending" />
          <StatCard label="Total Poin" value={data.total_poin} testId="emp-stat-poin" />
          <StatCard label="Rata-Rata Poin" value={data.rata_poin} testId="emp-stat-rata" />
        </div>
      </Window>
    </div>
  );
}
